import React from 'react';

import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import { withStyles } from '@material-ui/core/styles';
import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton/IconButton";

const drawerWidth = 376;

export const HeaderAdmin = styled.div`
    margin-left: ${props=>props.open ? `${props.drawerWidth}px`: '0' };
    height: 120px;
    width: 100%;
    background-color: #F2F6FC;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.15);
    position: fixed;
    z-index: 1201;
    transition: margin 0.2s;
    top:0;
    display: flex;
    align-items: center;
`;

export const HeaderTitle = styled.span`
    margin-left: 55px;
    font-size: 30px;
    font-weight: bold;
    font-family: "Times New Roman", Times;
`;

const IconButtonFunction = ({open,isWhite,...rest})=><IconButton {...rest}/>

export const IconButtonCustom = styled(IconButtonFunction)`
    &&&{
    display: ${props=>props.open ? 'none' : 'block'};
    margin-left: 10px;
    &:hover{
        background-color:inherit !important;
        color: ${props=>props.isWhite ? '#eaeaea' : '#000'};
    }
    color:${props=>props.isWhite ? '#fff' : '#5e5e5e'}
    }
`

const styles = theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing.unit*10 + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing.unit * 8 + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 3,
    },
});


class Admin extends React.Component {
  state = {
    selectedIndex: 0,
    open:true,
  };
    handleDrawerOpen = () => {
        this.setState({ open: true });
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };
  handleListItemClick = index => {
    this.setState({ selectedIndex: 5 },//fix for rerender on link click
        ()=>this.setState({ selectedIndex: index })
        );

  };

  render() {
      const { classes, theme } = this.props;
    return (
      <div>
        <Header selectedIndex={this.state.selectedIndex} open={this.state.open} drawerWidth={drawerWidth} handleDrawerClose={this.handleDrawerClose} handleDrawerOpen={this.handleDrawerOpen} />
        <Sidebar drawerWidth={drawerWidth} open={this.state.open} classes={classes} theme={theme} handleDrawerClose={this.handleDrawerClose} handleDrawerOpen={this.handleDrawerOpen} trigerHandleListItemClick={this.handleListItemClick} />
        <Dashboard open={this.state.open} selectedIndex={this.state.selectedIndex} />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Admin);
